var moduleMap = {
	"./PdfReport": function() {
		return __webpack_require__.e(523).then(function() { return function() { return (__webpack_require__(1309)); }; });
	},
	"./DefiReport": function() {
		return __webpack_require__.e(2903).then(function() { return function() { return (__webpack_require__(40593)); }; });
	},
	"./ScreeningReport": function() {
		return __webpack_require__.e(7146).then(function() { return function() { return (__webpack_require__(55466)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});